import { Grid, Typography } from "@mui/material";
import FormField from "../../../components/common/FormField";
import { feedbackFields } from "./userAllFields";
import useStyles from "../../../components/common/model/styles";
import CustomButton from "../../../components/common/button/CustomButton";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addFeedbackAction,
  getAllFeedbackListAction,
  setAddFeedbackResponse,
} from "../../../store/reducers/feedbackSlice";
import { initialFeedbackForm } from "./feedBackUtils";

const CustomerFeedback = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { feedbacks, isAddFeedbackResponse } = useSelector(
    (state: any) => state.feedback,
  );

  // Initialize form data with initialFeedbackForm
  const [formData, setFormData] = useState(initialFeedbackForm);

  // Fetch feedback list and reset the add feedback response flag
  useEffect(() => {
    dispatch(getAllFeedbackListAction());
    dispatch(setAddFeedbackResponse(false));
  }, [dispatch, isAddFeedbackResponse]);

  // Set form data when feedbacks are available, but only once (or based on a condition)
  useEffect(() => {
    if (feedbacks) {
      const updatedFormData = formData.map((feedbackItem) => {
        const feedback = feedbacks.find(
          (fb: any) => fb.question_id === feedbackItem.question_id,
        );
        return feedback
          ? { ...feedbackItem, question_text: feedback.question_text }
          : feedbackItem;
      });

      setFormData(updatedFormData);
    }
  }, [feedbacks]);

  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

  const onChangeAction = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = event.target;
    // Update the corresponding question_text for the given question_id (id)
    setFormData((prevFormData) =>
      prevFormData.map((item) =>
        item.question_id === parseInt(id)
          ? { ...item, question_text: value }
          : item,
      ),
    );
  };

  // Enable the submit button if any of the required fields (q1 to q5) have values
  useEffect(() => {
    const hasValue = formData
      .filter((item) => item.question_id >= 1 && item.question_id <= 5)
      .some((item) => item.question_text.trim() !== "");
    setIsSubmitDisabled(!hasValue);
  }, [formData]);

  // Handle form submission
  const handleSubmit = () => {
    // Directly using formData as the payload
    const dynamicPayload = formData;
    // Dispatch the action with the dynamic payload
    dispatch(addFeedbackAction(dynamicPayload));
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <Typography variant="h5" fontWeight={700}>
        Feedback Questions
      </Typography>
      <Grid
        container
        spacing={2}
        sx={{
          padding: "10px",
          mt: 1,
          background: "#E5F4F1",
          borderRadius: "5px",
          border: "1px solid #CFCFCF",
        }}
      >
        <Grid
          item
          md={12}
          xs={12}
          sx={{ paddingLeft: "0px !important", paddingRight: "16px" }}
        >
          <Grid container spacing={2}>
            {feedbackFields &&
              feedbackFields.map((field) => (
                <FormField
                  key={field.id}
                  // onPaste={(e) => e.preventDefault()}
                  onKeyDown={(event: any) => {
                    if (
                      event.key === "Backspace" ||
                      event.key === "Tab" ||
                      event.key === "Enter" ||
                      event.key.startsWith("Arrow") ||
                      event.ctrlKey
                    ) {
                      return;
                    }
                  }}
                  {...{
                    ...field,
                    value:
                      formData.find(
                        (item: any) => item.question_id === parseInt(field.id),
                      )?.question_text || "",
                    variant: "outlined",
                    minRows: 2,
                    isNonMarginTop: true,
                    inSingleGridForm: true,
                    onChange: onChangeAction,
                    maxLength: 250,
                    InputProps: {
                      ...(field?.inputProps && field?.inputProps),
                      sx:
                        field?.type === "text" || field?.type === "password"
                          ? { height: "36px" }
                          : {
                              padding: "10px 4px",
                              height: "36px",
                            },
                    },
                  }}
                />
              ))}
          </Grid>
        </Grid>
        <Grid item md={12} xs={12} display={"flex"} justifyContent={"flex-end"}>
          <CustomButton
            disabled={isSubmitDisabled}
            style={{ width: "120px" }}
            title={"Save"}
            onClick={handleSubmit}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default CustomerFeedback;
